jQuery( function( $ ) {
  $('.entry-media, .entry-gallery').each( function() {
  	var e = $( this );
    e.insertBefore( e.closest( 'article' ).find( 'header' ) )
  } );
  
  $( document ).delegate( '.add_to_cart_button', 'click', function() {
  	
    $( this ).addClass( 'loading' ).closest( '.product-wrapper' ).find( 'form.cart [type="submit"]' ).click();
    
    return false;
  } );
} );

jQuery(function($) {
  $( document ).delegate( '.page-content-contact .bs-tab-nav a', 'shown.bs.tab', function() {
  	var e = $( this.hash ).find( '.xultimate-map-wrapper' ).removeClass( 'xultimate-map-wrapper' )
    	,em = e.find( '[data-latlag]' )
    ;
    
    if( em.find( '.gm-style' ).length )
    {
     	return false; 
    }
    
    var map_map_569149f87ed0b = null;
    var coordinate_map_569149f87ed0b;
    var isDraggable = $(document).width() > 641 ? true : true;
    try {
      var map_map_569149f87ed0b = null;
      var coordinate_map_569149f87ed0b;
      coordinate_map_569149f87ed0b = eval('new google.maps.LatLng('+em.attr( 'data-latlag' )+')');
      var mapOptions = {
        zoom: 12,
        center: coordinate_map_569149f87ed0b,
        scaleControl: true,
        streetViewControl: false,
        mapTypeControl: false,
        panControl: false,
        zoomControl: false,
        scrollwheel: true,
        draggable: isDraggable,
        zoomControlOptions: {
          style: google.maps.ZoomControlStyle.SMALL
        },
        mapTypeId: google.maps.MapTypeId.ROADMAP,
      };
      var map_map_569149f87ed0b = new google.maps.Map(em.get(0), mapOptions);
      var x = '';
      var marker_map_569149f87ed0b = new google.maps.Marker({
        position: new google.maps.LatLng(51.507622, -0.127697),
        animation: google.maps.Animation.DROP,
        map: map_map_569149f87ed0b,
        icon: ''
      });
      google.maps.event.addListener(marker_map_569149f87ed0b, 'click', toggleBounce);
    } catch (e) {};
  } );
  
  $( '.page-content-contact .bs-tab-nav a' ).first().tab('show');
});
